export enum OccupationalHealthCertificateSituationType {
    // 1 - Em dia
    UP_TO_DATE = "UP_TO_DATE",
    // 2 - Expirado
    EXPIRED = "EXPIRED",
}
